import LoginId    from "../authentication/LoginId";
import GenderType from "../fundamentals/gender/GenderType";
import Name       from "../fundamentals/name/Name";
import StaffId    from "./StaffId";
import StaffMemo  from "./StaffMemo";

class Staff {
  constructor(
    private readonly _id: StaffId = new StaffId(),
    private readonly _name: Name = new Name(),
    private readonly _genderType: GenderType = GenderType.NOT_KNOWN,
    private readonly _memo: StaffMemo = new StaffMemo(),
    private readonly _loginId: LoginId = LoginId.empty(),
  ) {}

  public isEmpty(): boolean {
    return isNaN(this._id.value);
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get genderType() {
    return this._genderType;
  }

  get memo() {
    return this._memo;
  }

  get loginId() {
    return this._loginId;
  }

  public genderLabel(): string {
    switch (this._genderType) {
      default:
      case GenderType.NOT_KNOWN:
        return "未選択";
      case GenderType.MALE:
        return "男性";
      case GenderType.FEMALE:
        return "女性";
      case GenderType.NOT_APPLICABLE:
        return "その他";
    }
  }
}

export default Staff;
